import { Record, List } from 'immutable';
import logger from '~/utils/logger/logger';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import type {
  SharedFilterMethods,
  SharedFilterFields,
} from '../../types/filter-value-types';
import type {
  FilterDefinitionType,
  TagFilterDefinitionTypeRecord,
} from '../../data/definitions';
import FilterDefinitionValueRecord from '../FilterDefinitionValueRecord';
import NameRecord from '../NameRecord';

const keys: Fields = {
  filterName: new NameRecord(),
  selectedOptions: List(),
  type: FilterDefinitionTypeConstants.MULTI_SELECT_TAGS,
};

export interface Fields extends SharedFilterFields {
  selectedOptions: List<FilterDefinitionValueRecord>;
  type: FilterDefinitionTypeConstants.MULTI_SELECT_TAGS;
}

export default class TagFilterRecord
  extends Record<Fields>(keys)
  implements SharedFilterMethods {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};
    if (values) {
      if (Array.isArray(values.selectedOptions)) {
        newValues.selectedOptions = List(
          values.selectedOptions.map(
            (val) => new FilterDefinitionValueRecord(val)
          )
        );
      }
    }
    return this.merge(newValues);
  }

  getFilterKey() {
    return this.filterName.getName();
  }

  getType() {
    return this.type;
  }

  getName() {
    return this.getTagCategory();
  }

  getLabel() {
    return this.getTagCategory();
  }

  getValues(): List<FilterDefinitionValueRecord> {
    return this.selectedOptions;
  }

  getTagCategory(): string {
    return this.filterName.getLabel() || 'NO_LABEL';
  }

  add(newValue: FilterDefinitionValueRecord) {
    if (this.selectedOptions.contains(newValue)) {
      return this;
    }
    return this.set('selectedOptions', this.selectedOptions.push(newValue));
  }

  removeValue(valueToRemove: FilterDefinitionValueRecord) {
    if (this.selectedOptions.contains(valueToRemove)) {
      if (this.selectedOptions.size <= 1) {
        return null;
      }
      return this.set(
        'selectedOptions',
        this.selectedOptions.filter((v) => v !== valueToRemove)
      );
    }

    logger.error('Filter value not found');
    return this;
  }

  updateFromDefinition(uncastDef: FilterDefinitionType): this {
    const def = uncastDef as TagFilterDefinitionTypeRecord;
    const options = def.getOptions();

    const newValues = this.getValues().map((value) => {
      return options.find((o) => o.getValue() == value.getValue()) || value;
    });

    return this.merge({
      filterName: def.getNameRecord(),
      selectedOptions: newValues,
    });
  }
}
